import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { Context } from '../context';

export const AlumniMeta = () => {
  const { alumni } = useParams();
  const context = useContext(Context);
  const alumniHandle = alumni;
  const alumnuData = context.x.getAlumniByHandle(alumniHandle) || {};


  // You can customize these values based on your needs
  const title = `${alumnuData.name}'s Portfolio | Gnomon Alumni`;
  const description = `View ${alumnuData.name}'s portfolio and work from Gnomon School of Visual Effects`;
  const imageUrl = alumnuData.demoReelCover; // Replace with your actual image URL

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={window.location.href} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />
    </Helmet>
  );
};